import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ChangeVideoStreamStatus,
  setCurrentChannelInformation,
  setOpenStreamCamera,
} from "../../../../../../Redux/Actions/VideoStreamingActions";
import userService from "../../../../../../services/user.service";
import {
  openFailDialog,
  openSuccessPopup,
} from "../../../../../../Redux/Actions/PopupActions";
import { getFromLocalStorage } from "../../../../../../utils/webStorage";
import Hls from "hls.js";
import moment from "moment";
const useStream = () => {
  const schoolId = getFromLocalStorage("schoolId");
  const userId = getFromLocalStorage("currentUserId");
  const [isLive, setIsLive] = useState(false);
  const [streamLoading, setStreamLoading] = useState(false);
  const dispatch = useDispatch();
  const videoStreamAvsChannelList = useSelector(
    (state) => state?.videoStreamData?.videoStreamAvsChannelList
  );
  const currentChannel = useSelector(
    (state) => state?.videoStreamData?.currentChannel
  );
  // Helper function to check if the stream can play
  const canPlayStream = async (playbackUrl) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      const delayedResolve = (value) => {
        setTimeout(() => resolve(value), 5000); // Delay resolution by 5 seconds
      };
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(playbackUrl);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          delayedResolve(true);
        });
        hls.on(Hls.Events.ERROR, () => {
          resolve(false);
        });
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = playbackUrl;
        video.addEventListener("loadedmetadata", () => {
          //resolve(true);
          delayedResolve(true);
        });
        video.addEventListener("error", () => {
          resolve(false);
        });
      } else {
        resolve(false);
      }
    });
  };

  const startStream = async ({
    channelType,
    client,
    handleError,
    streamVideo,
    socket,
  }) => {
    try {
      // var timer;
      // Set the ingest server to re-validate it before attempting to start the stream.
      client.config.ingestEndpoint = currentChannel?.ingestUrl;
      // Set a timeout on the stream to show an alert if the stream is taking longer than intended to start.
      // timer = setTimeout(() => {
      //   handleError(
      //     "It's taking longer than usual to start the stream. Check the status of your internet connection and disable any active VPNs."
      //   );
      //   setIsLive(false);
      //   ChangeVideoStreamStatus(dispatch, false);
      //   setStreamLoading(false);
      // }, 60000);
      setStreamLoading(true);
      // Resume the audio context to prevent audio issues when starting a stream after idling on the page in some browsers.
      await client.getAudioContext().resume();
      // Attempt to start the broadcast
      await client.startBroadcast(currentChannel?.streamKey);
      // clearTimeout(timer); //Clear the timer if the stream starts successfully
      //to update stream start timestamp
      const checkPlayback = async (attempts = 10) => {
        for (let i = 0; i < attempts; i++) {
          try {
            const canPlay = await canPlayStream(currentChannel.playbackUrl);
            if (canPlay) {
              userService
                .getStreamMetadata({ channelArn: currentChannel?.channelArn })
                .then((response) => {
                  userService
                    .updateStreamingStartTime({
                      id: currentChannel?.id,
                      streamingStartTime: moment(response?.startTime).format(
                        "YYYY-MM-DD HH:mm:ss"
                      ),
                    })
                    .then((response) => {
                      setIsLive(true);
                      streamVideo();
                      setStreamLoading(false);
                      ChangeVideoStreamStatus(dispatch, true);
                      setCurrentChannelInformation(dispatch, {
                        currentChannel,
                        channelStatus: true,
                        videoStreamAvsChannelList,
                        schoolId,
                        socket,
                      });
                      const sideBarElement = document.querySelector(
                        "#schoolAdminSidebar"
                      );
                      if (sideBarElement) {
                        sideBarElement.style.pointerEvents = "none";
                      }
                      const headerElement = document.querySelector(
                        ".MuiToolbar-regular"
                      );
                      if (headerElement) {
                        headerElement.style.pointerEvents = "none";
                      }
                    })
                    .catch((error) => {
                      throw error;
                    });
                });
              return;
            }
          } catch (error) {
            throw error;
          }
          // Retry after 3 second seconds if playback is not ready
          await new Promise((resolve) => setTimeout(resolve, 3000));
        }
        // If playback is not ready after all attempts
        handleError(
          "Stream is not playing. Please check your stream settings and try again."
        );
        setIsLive(false);
        ChangeVideoStreamStatus(dispatch, false);
        setStreamLoading(false);
      };
      //send live stream notification if it is first channel which got started
      if (videoStreamAvsChannelList.length == 0) {
        await userService.sendLiveStreamingNotification({
          id: userId,
          schoolId,
          associationType: "Started Stream",
        });
      }
      //If channel already present
      const availableChannel = videoStreamAvsChannelList.filter(
        (ele) => ele.userId.toString() === userId
      );
      if (availableChannel.length > 0) {
        const { id, channelArn } = availableChannel[0];
        await userService.deleteChannel([channelArn]);
        const result = await userService.updateChannelStatus([
          {
            id,
            isAssigned: false,
          },
        ]);
        socket.emit("stopStreaming", result?.data?.data);
      }
      //Start checking playback
      await checkPlayback();
    } catch (err) {
      // clearTimeout(timer);
      let errorMessage;
      switch (err.code) {
        case 10000:
          errorMessage = `Error starting stream: Your stream settings are misconfigured. This is likely caused by mismatched channel types. The Channel type you selected: ${
            channelType === "STANDARD" ? "Standard" : "Basic"
          }, must match the channel type of your Amazon IVS Channel.`;
          break;
        default:
          errorMessage = `Error starting stream: ${err.message}.`;
          break;
      }

      handleError(errorMessage);
      setIsLive(false);
      ChangeVideoStreamStatus(dispatch, false);
      setStreamLoading(false);
    }
  };

  const stopStream = async (client, handleError, socket) => {
    const channelForDelete = videoStreamAvsChannelList.find(
      (ele) => userId === ele?.userId?.toString()
    );
    try {
      if (
        channelForDelete?.isPrimaryChannel &&
        videoStreamAvsChannelList?.length !== 1
      ) {
        openFailDialog(dispatch, {
          open: true,
          message: "This is parent channel. Please stop other channel first.",
        });
      } else {
        setStreamLoading(true);
        await client.stopBroadcast();
        setIsLive(false);
        userService
          .deleteChannel([channelForDelete?.channelArn])
          .then((response) => {
            if (videoStreamAvsChannelList.length == 1) {
              userService.sendLiveStreamingNotification({
                id: userId,
                schoolId,
                associationType: "Stopped Stream",
              });
            }
            setCurrentChannelInformation(dispatch, {
              currentChannel: channelForDelete,
              channelStatus: false,
              videoStreamAvsChannelList: videoStreamAvsChannelList,
              schoolId: schoolId,
              socket: socket,
            });
            setStreamLoading(false);
            setOpenStreamCamera(dispatch, false);
            ChangeVideoStreamStatus(dispatch, false);
            const sideBarElement = document.querySelector(
              "#schoolAdminSidebar"
            );
            if (sideBarElement) {
              sideBarElement.style.pointerEvents = "auto";
            }
            const headerElement = document.querySelector(".MuiToolbar-regular");
            if (headerElement) {
              headerElement.style.pointerEvents = "auto";
            }

            openSuccessPopup(dispatch, {
              successPopUp: {
                message: "Stream Stopped Successfully",
                open: true,
              },
            });
          })
          .catch((error) => {
            throw error;
          });
      }
    } catch (err) {
      setStreamLoading(false);
      handleError(`${err.name}: ${err.message}`);
      ChangeVideoStreamStatus(dispatch, false);
      setCurrentChannelInformation(dispatch, {
        currentChannel: channelForDelete,
        channelStatus: false,
        videoStreamAvsChannelList: videoStreamAvsChannelList,
        schoolId: schoolId,
      });
    } finally {
      return;
    }
  };

  const toggleStream = async ({
    channelType,
    client,
    handleError,
    streamVideo,
    socket,
  }) => {
    if (isLive) {
      stopStream(client, handleError, socket);
    } else {
      startStream({
        channelType,
        client,
        handleError,
        streamVideo,
        socket,
      });
    }
  };

  return {
    isLive,
    streamLoading,
    toggleStream,
  };
};

export default useStream;
